import { useEffect, useState } from "react";
import { FormikProps, withFormik } from "formik";
import { string, object } from "yup";
import { Input } from "../shared/Input";
import { Button } from "../shared/Button";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export interface ILoginProps {
  onSubmit: (values: any, actions: any, selectedCartItem?: any) => void;
  setSignUpForm: (value: boolean) => void;
  setChangePasswordForm: (value: boolean) => void;
  setForgotPasswordForm: (value: boolean) => void;
  setResetPasswordForm: (value: boolean) => void;
  onSocialLogin: (response: any) => void;
  selectedCartItem?: any;
  incorrectCreds?: boolean;
  setIncorrectCreds?: (value: boolean) => void;
}

interface FormikValues {
  userName: string;
  password: string;
}

function Login(props: FormikProps<FormikValues> & ILoginProps) {
  const [showPassword, setShowPassword] = useState(false);

  // useEffect(() => {
  //   // Disable body scrolling when this component is mounted
  //   document.body.classList.add("body-no-scroll");

  //   // Cleanup function to remove the class when unmounted
  //   return () => {
  //     document.body.classList.remove("body-no-scroll");
  //   };
  // }, []);
  useEffect(() => {
    if (props?.setIncorrectCreds) {
      props?.setIncorrectCreds(false);
    }
  }, []);

  return (
    <GoogleOAuthProvider clientId="283137376225-1itf8dsud8m57m8b7mhfnokh9ugpi7ek.apps.googleusercontent.com">
      <form
        onSubmit={props.handleSubmit}
        className="form-container scrollbar-hide flex-grow"
      >
        <div className="flex items-center justify-center bg-white min-h-0.5">
          <div className="bg-white rounded-lg w-full max-w-sm p-4">
            <p className="text-xs text-gray-600 mb-4 text-justify">
              Please login to continue to your account.
            </p>

            {props.incorrectCreds && (
              <p className="text-xs text-red-600 mb-4 text-justify">
                Incorrect credentials. Please try again.
              </p>
            )}

            <div className="space-y-3">
              {/* Email Input */}
              <Input
                label="Email"
                name="userName"
                values={props.values}
                errors={props.errors}
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                touches={props.touched}
                placeholder="Enter your email"
                className="block w-full px-2 mt-2 py-2 border text-xs border-[#b0afb3] rounded-md focus:border-[#b0afb3] focus:outline-none"
              />

              <div className="relative">
                <Input
                  label="Password"
                  name="password"
                  values={props.values}
                  errors={props.errors}
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  touches={props.touched}
                  placeholder="Enter your password"
                  className="block w-full px-2 mt-2 py-2 border text-xs border-[#b0afb3] rounded-md focus:border-[#b0afb3] focus:outline-none"
                  type={showPassword ? "text" : "password"}
                />
                <span
                  className="absolute right-3 top-[42px] transform  cursor-pointer text-gray-500"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <div className="mt-2 text-xs text-[#05A30D] flex justify-between">
                <a
                  href="#"
                  className="ml-auto"
                  onClick={() => props.setForgotPasswordForm(true)}
                >
                  Forgot password?
                </a>
              </div>

              {/* Submit Button */}
              <Button
                className="bg-[#00B207] hover:opacity-70 rounded-full text-white py-2 w-full mt-4 hover:scale-105 duration-300"
                name={props.isSubmitting ? "Logging In..." : "LOGIN"}
                type="submit"
                loading={props.isSubmitting}
                disabled={props.isSubmitting}
              />
            </div>

            <div className="flex justify-center mt-4">
              <GoogleLogin
                onSuccess={props.onSocialLogin}
                width={300}
                logo_alignment="center"
              />
            </div>
            <div className="mt-4 text-gray-400">
              <p className="text-xs">
                Need an account?
                <span
                  className="text-green-500 underline ml-1 cursor-pointer"
                  onClick={() => props.setSignUpForm(true)}
                >
                  Create One
                </span>
              </p>
            </div>
          </div>
        </div>
      </form>
    </GoogleOAuthProvider>
  );
}

export default withFormik<ILoginProps, FormikValues>({
  validationSchema: object().shape({
    userName: string().required("Email is required"),
    password: string().required("Password is required"),
  }),
  mapPropsToValues: () => ({
    userName: "",
    password: "",
  }),
  handleSubmit: (values, { props, setSubmitting }) => {
    props.onSubmit(values, { setSubmitting }, props.selectedCartItem);
  },
})(Login);
